export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/new-bie/red-packet' */ './RedPacket'
  );
